export { default } from "./blankPanel";
